class OutfitProductItemUtilities {
  constructor(productHandle) {
    this.productHandle = productHandle;
    this.activeVariant = null;
    this.sliderCellSelectorString = "slider_active_image";
  }

  getOutfitProductItemContainer(handle) {
    return document.querySelector(
      `.product_outfit_item[data-outfit-product-handle=${handle}]`
    );
  }

  setFlickitySlider(gallery) {
    return new Flickity(gallery, {
      pageDots: false,
      contain: true,
      cellSelector: ".slider_active_image",
    });
  }

  getInputValue(element, datasetItem = false, inputValue = false) {
    if (datasetItem) {
      return element.dataset[datasetItem];
    }

    if (inputValue) {
      return element.value;
    }
  }

  getOutfitProductDefaultSelectedVariant(handle) {
    const product = OutfitProductsData[handle];
    const defaultSelectedVariant = product.defaultSelectedVariant;
    const variant = product.variants.filter(
      (variant) => variant.id === defaultSelectedVariant
    );
    this.activeVariant = variant[0];
    return variant[0];
  }

  updateActiveVariant(color = false, size = false) {
    const product = OutfitProductsData[this.productHandle];
    const variant = product.variants.find((variant) => {
      return color
        ? variant.options.color === color && variant.options.size === size
        : variant.options.size === size;
    });
    this.activeVariant = variant;
  }
}

class OutfitProductItem extends OutfitProductItemUtilities {
  constructor(productHandle) {
    super(productHandle);

    this.container = this.getOutfitProductItemContainer(this.productHandle);

    // Setup gallery
    this.galleryElement = this.container.querySelector(
      `[data-gallery-for="${this.productHandle}"] .product_outfit_item_gallery_target`
    );

    this.gallerySlider = null;

    // Setup options
    this.colorOptions = this.container.querySelector(
      `[data-product-option-for="${this.productHandle}"][data-product-option="color"]`
    );

    this.sizeOption = this.container.querySelector(
      `[data-product-option-for="${this.productHandle}"] .outfit_product_size`
    );

    // Setup CTA
    this.getNotifiedCTA = this.container.querySelector(
      ".outfit_product_get_notified"
    );

    this.addToCartCTA = this.container.querySelector(
      ".outfit_product_add_to_cart"
    );

    this.onInitializeElements();
  }

  onInitializeElements() {
    this.addToCartCTA.addEventListener("click", this.onAddToCart.bind(this));
    this.colorOptions.addEventListener(
      "click",
      this.handleSetColorOption.bind(this)
    );
    this.sizeOption.addEventListener(
      "change",
      this.handleSetSizeOption.bind(this)
    );

    const variantObj = this.getOutfitProductDefaultSelectedVariant(
      this.productHandle
    );

    const { options } = variantObj;

    Object.entries(options).forEach(([key, value]) => {
      if (key === "color") {
        const selectedColorOption = this.colorOptions.querySelector(
          `[data-option-color="${value}"]`
        );
        selectedColorOption.dataset.colorOptionIsSelected = true;

        this.colorOptions.querySelector(
          ".outfit_product_selected_color"
        ).innerHTML = value;

        this.onFilterGallery(value);
        this.gallerySlider = this.setFlickitySlider(this.galleryElement);
      }

      if (key === "size") {
        this.sizeOption.value = value;
      }
    });

    this.updateCTAButtonAvailability();
  }

  handleSetColorOption(e) {
    const optionEl = e.target.closest(".outfit_product_color");
    if (!optionEl) return;
    const value = this.getInputValue(optionEl, "optionColor");
    this.onColorChange(value);
  }

  handleSetSizeOption(e) {
    const optionEl = e.target.closest(".outfit_product_size");
    if (!optionEl) return;
    this.onSetActiveVariant();
  }

  onFilterGallery(color) {
    let filteredImagesArray = [];

    // Reset gallery
    const images = this.galleryElement.querySelectorAll(
      ".outfit_product_image"
    );

    images.forEach((item) =>
      item.classList.remove(this.sliderCellSelectorString)
    );

    const filteredByColor = this.galleryElement.querySelectorAll(
      `.outfit_product_image[data-gallery-image="${color}"]`
    );

    if (!filteredByColor.length) {
      const showAllImages = this.galleryElement.querySelectorAll(
        `.outfit_product_image[data-gallery-image="show_all"]`
      );
      filteredImagesArray.push(...showAllImages);
    } else {
      filteredImagesArray.push(...filteredByColor);
    }

    filteredImagesArray.forEach((el) =>
      el.classList.add(this.sliderCellSelectorString)
    );
  }

  onColorChange(value) {
    this.colorOptions
      .querySelectorAll(".outfit_product_color")
      .forEach((el) => (el.dataset.colorOptionIsSelected = false));

    this.colorOptions.querySelector(
      `[data-option-color="${value}"]`
    ).dataset.colorOptionIsSelected = true;

    this.colorOptions.querySelector(
      ".outfit_product_selected_color"
    ).innerHTML = `${value.replace("-", " ")}`;

    // Gallery
    this.gallerySlider.destroy();
    this.onFilterGallery(value);
    this.gallerySlider = this.setFlickitySlider(this.galleryElement);

    this.onSetActiveVariant();
  }

  onSetActiveVariant() {
    const selectedColor = this.getSelectedColor();
    const selectedSize = this.getSelectedSize();
    this.updateActiveVariant(selectedColor, selectedSize);
    this.updateCTAButtonAvailability();
  }

  getSelectedColor() {
    return this.colorOptions.querySelector(
      `[data-color-option-is-selected="true"]`
    ).dataset.optionColor;
  }

  getSelectedSize() {
    return this.sizeOption.value;
  }

  updateCTAButtonAvailability() {
    if (this.activeVariant.isAvailable) {
      this.setAddToCartCTA(true);
      this.setGetNotifiedCTA(false);
    } else {
      this.setAddToCartCTA(false);
      this.setGetNotifiedCTA(true);
    }
  }

  setAddToCartCTA(newState) {
    this.addToCartCTA.dataset.ctaIsActive = newState;
  }

  setGetNotifiedCTA(newState) {
    this.getNotifiedCTA.dataset.ctaIsActive = newState;
  }

  async onAddToCart() {
    if (!this.activeVariant.isAvailable) return;
    let data = {
      items: [
        {
          id: this.activeVariant.id,
          quantity: 1,
        },
      ],
    };

    try {
      const req = await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      const res = await req.json();

      if (!req.ok || !res.items.length)
        throw new Error(
          "Oops! Something went wrong. Please try to add your product again. If this message persists, the item may not be available."
        );

      showAjaxCart();
    } catch (error) {
      alert(error.message);
      console.log(`Outfit Product | onAddToCart() | ${error}`);
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const outfitProductsContainer = document.querySelector(
    ".product__outfit_products_items"
  );

  if (outfitProductsContainer.dataset.hasItems === "true") {
    // Selecting Items
    const outfitProductsItems = outfitProductsContainer.querySelectorAll(
      ".product_outfit_item"
    );

    // Initialize each Product Item
    outfitProductsItems.forEach((item) => {
      const outfitItem = new OutfitProductItem(
        item.dataset.outfitProductHandle
      );
    });
  }
});
